var map = {
	"./Atta, Rice & Dal.png": 316,
	"./Baby Care.png": 317,
	"./Biscuit, Chips & Namkeen.png": 318,
	"./Chocolates & Ice Cream.png": 319,
	"./Cleaning Essentials.png": 320,
	"./Cold Drinks & Juices.png": 321,
	"./Combos.png": 322,
	"./Dairy & Bread.png": 323,
	"./Dry Fruits & Vrat Items.png": 324,
	"./Ghee, Oil & Masala.png": 325,
	"./Hygiene & Shaving.png": 326,
	"./Instant Food.png": 327,
	"./Other Home Items.png": 328,
	"./Personal Care.png": 329,
	"./Sauces & Spreads.png": 330,
	"./Tea & Coffee.png": 331
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 315;